module.exports = __webpack_public_path__ + "img/3.8b74ebe9.png";